export const phone = /^(0{1}\d{9})?$/;